import { MuiThemeProvider } from "@material-ui/core/styles";
import * as React from "react";

import JobsPage from "./components/JobsPage";
import { DefaultTheme } from "./theme/MuiTheme";

class App extends React.Component {
  public render() {
    return (
      <MuiThemeProvider theme={DefaultTheme}>
        <JobsPage />
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx